import { defineMessages } from 'react-intl';

export const trialEndReminderPopupMessages = defineMessages({
  ariaLabel: {
    defaultMessage: 'Trial ending soon reminder',
    id: '3lAyigJpQ4',
    description: 'Accessible label for the trial-ending reminder popup card',
  },
  title: {
    defaultMessage:
      '{daysLeft, plural, one {# day left of complimentary {featureName} features} other {# days left of complimentary {featureName} features}}',
    id: '0GcLucA1J1',
    description:
      'Heading on the trial-ending reminder popup; shows days remaining and the trial tier name',
  },
  description: {
    defaultMessage: "See how you've used Evidence in the last 90 days.",
    id: 'CV6X4M1BAR',
    description:
      'Body on the trial-ending reminder popup inviting the user to open the trial recap',
  },
  descriptionTeamAdmin: {
    defaultMessage: 'See how your team has been using the new {planName} plan.',
    id: 'PLzBkyJaC9',
    description:
      'Body on the trial-ending reminder popup for team admins; invites opening the recap with team-focused wording',
  },
  descriptionNonAdminNoUsage: {
    defaultMessage: "See what's possible before it's gone.",
    id: 'ERLuhpP0fR',
    description:
      'Body on the trial-ending reminder popup for non-admins with no trial usage yet',
  },
  seeRecap: {
    defaultMessage: 'See recap',
    id: 'GQ2uBQdEUc',
    description:
      'CTA button on the trial-ending reminder popup that opens the trial recap modal',
  },
  takeALook: {
    defaultMessage: 'Take a look',
    id: '3ULKtsqhQk',
    description:
      'CTA button on the trial-ending reminder popup that opens the trial recap modal for users with no usage',
  },
  close: {
    defaultMessage: 'Close',
    id: 'tHdqGo73MI',
    description: 'Accessible label for the close (X) icon button on the popup',
  },
  clinicianPlanName: {
    defaultMessage: 'Clinician',
    id: 'UNcXEG36Qj',
    description: 'Display name for the Clinician plan',
  },
  practicePlanName: {
    defaultMessage: 'Practice',
    id: 'LImo2lUg1g',
    description: 'Display name for the Practice plan',
  },
  evidenceFeatureName: {
    defaultMessage: 'Evidence',
    id: 'udmizbvpyq',
    description: 'Display name for the Evidence feature (part of Practice trial)',
  },
});
